export const SITE = {
  name: "Porter New Orleans",
  legalName: "Porter New Orleans, LLC",
  instagram: "https://www.instagram.com/porterneworleans",
  domain: "https://www.porterneworleans.com",
  founded: "2016",
  rate: "$85/hour",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Gallery", to: "/gallery" },
  { label: "Contact", to: "/contact" },
];

const u = (id, w = 1400) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

export const IMAGES = {
  workCloset: "/assets/work/IMG_8687.jpg",
  workPantryLabeled: "/assets/work/IMG_8686.jpg",
  workPantryWalkin: "/assets/work/IMG_8691.jpg",
  workShoes: "/assets/work/IMG_8690.jpg",
  workPantryMarigny: "/assets/work/IMG_8689.jpg",
  workClosetMandeville: "/assets/work/IMG_8692.jpg",
  workShoesHisHers: "/assets/work/IMG_8694.jpg",
  workFridge: "/assets/work/IMG_8695.jpg",
  workManCave: "/assets/work/IMG_8696.jpg",
  workPantryLakeview: "/assets/work/IMG_8698.jpg",
  workToyBins: "/assets/work/IMG_8699.jpg",
  workBookshelf: "/assets/work/IMG_8700.jpg",
  workGirlsCloset: "/assets/work/IMG_8701.jpg",
  workSpices: "/assets/work/IMG_8702.jpg",
  workDecanted: "/assets/work/IMG_8705.jpg",
  workKitchen: "/assets/work/IMG_8707.jpg",
  workMensCloset: "/assets/work/IMG_8709.jpg",
  hero: u("photo-1592401526914-7e5d94a8d6fa", 1600),
  closet: u("photo-1785395407788-71b829c98bb4", 1200),
  pantry: u("photo-1786398018370-079064d79d84", 1200),
  nola: u("photo-1640583430339-f83d93e77413", 1400),
  livingRoom: u("photo-1554995207-c18c203602cb", 1400),
  kitchen: u("photo-1556911220-bff31c812dba", 1400),
  apartment: u("photo-1484154218962-a197022b5858", 1400),
  desk: u("photo-1524758631624-e2822e304c36", 1400),
  bedroom: u("photo-1616486338812-3dadae4b4ace", 1400),
  workspace: u("photo-1507089947368-19c1da9775ae", 1400),
  hallway: u("photo-1600607687939-ce8a6c25118c", 1400),
};

export const LOGO = "/assets/porter-logo.jpeg";
